import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../request';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
export default {
  props: {
    // item: {
    //   type: Object,
    //   default: () => {}
    // },
    // index: {
    //   type: Number,
    //   default: 0
    // },
    formDataArray: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  components: {
    previewModal // 声明组件
  },
  data() {
    return {
      action: uploadFile,
      datalist: [],
      //存储获取的文件数据
      dataurls: [],
      //存储url地址
      isUploadDisabled: true,
      // 初始化上传按钮禁用状态

      isModalVisible: false,
      //
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0
    };
  },
  computed: {},
  methods: {
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    // 文件上传逻辑
    clickPlusTWO() {
      // 文件的类型的数据
      // if (this.formDataArray.fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      console.log('dddddddddddd', file, fileList);
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }

      // const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // const fileType = file.type.split('/').pop().toLowerCase();
      const fileType = file.name.substring(file.name.lastIndexOf('.'));
      // 文件类型
      if (!this.formDataArray.fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return false;
      } else {
        // 文件列表
        this.datalist = fileList.map(item => {
          if (item.response && item.response.code === 200 && item.status === 'done') {
            item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
            // 将文件URL添加到templateUrl变量中
            // this.dataurls += item.url;
          }
          return item;
        });
        this.dataurls = this.datalist.map(item => item.url);
        console.log('获取附件上传信息', this.dataurls);
        this.$emit('update:controlMark', this.dataurls);
      }
    },
    // 附件上传新建
    beforeUpload(file) {
      console.log('file-------------', file);

      // if (this.formDataArray.fileFormat.length < 0) {
      //   this.$message.error('请选择文件格式');
      //   return false;
      // }
      // const extension = file.type.split('/').pop().toLowerCase();
      const extension = file.name.substring(file.name.lastIndexOf('.'));
      // console.log('file------extension-------', extension);
      // console.log('this.formDataArray.fileFormat------', this.formDataArray.fileFormat);
      // 文件类型
      // if (!this.formDataArray.fileFormat.includes(extension)) {
      //   this.$message.error(this.$t('文件格式错误'));
      //   return false;
      // }

      // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      const isValidType = this.formDataArray.fileFormat.includes(extension);
      console.log('file------isValidType------', isValidType);
      if (!isValidType) {
        this.$message.error(this.$t('文件格式错误'));
        return false;
      }
      const isValidSize = file.size / (this.formDataArray.fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.formDataArray.fileSize.size;
      if (!isValidSize) {
        this.$message.error(this.$t('文件大小超过限制'));
      }
      // return isValidType && isValidSize;
      // this.isUploadDisabled = false; // 符合条件时启用上传按钮
      return isValidType && isValidSize;
    },
    // beforeUpload(file) {
    //   const isJpgOrPng = file.type.split('/').pop().toLowerCase();
    //   if (!isJpgOrPng) {
    //     this.$message.error(this.$t('文件格式错误'));
    //   }
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isLt2M) {
    //     this.$message.error('Image must smaller than 2MB!');
    //   }
    //   return isJpgOrPng && isLt2M;
    // },

    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    async handlePreview(file) {
      // const extension = file.type.split('/').pop().toLowerCase();
      const extension = file.name.substring(file.name.lastIndexOf('.'));
      // 文件类型
      const isValidType = this.formDataArray.fileFormat.includes(extension);
      console.log('file------isValidType------', isValidType);
      if (!isValidType) {
        this.$message.error(this.$t('文件格式错误'));
        return false;
      }
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.formDataArray.templateUrl.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    removeUploadFile(file) {
      const index = this.dataurls.indexOf(file);
      const newFileList = this.dataurls.slice();
      // console.log('newFileList type:', typeof newFileList); // 检查newFileList的类型
      // console.log('newFileList:', newFileList); // 输出newFileList的内容
      newFileList.splice(index, 1);
      this.dataurls = newFileList;
      console.log('删除url地址', this.dataurls);
      this.$emit('update:controlMark', this.dataurls);
    }
  }
};